import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { Input, message } from 'antd';
import axios from '../../../util/Api';
import Item from '../../../components/Form/Item';

const PassportDetail = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [passport, setPassport] = useState({});

  useEffect(() => {
    if (formik.values.passport.id) {
      fetchPassportDetail();
    }
  }, [formik.values.passport.id]);

  const fetchPassportDetail = () => {
    setLoading(true);
    const url = `/passport/detail?id=${formik.values.passport.id}`;
    axios.get(url).then(resp => {
      setPassport(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data personel");
    });
  }

  return (
    <div className="gx-mt-3 gx-mb-3">
      {loading ? "Sedang memuat..." : (
        <>
          <Item name="Nama">
            <Input readOnly value={passport.name} />
          </Item>
          <Item name="Nama Perusahaan / Mandor">
            <Input readOnly value={passport.vendor.name} />
          </Item>
          <Item name="Kategori">
            <Input readOnly value={passport.vendor.type.label} />
          </Item>

          <h4 className="gx-mt-3 gx-mb-3">Bekerja di Proyek</h4>

          <Item name="Divisi Operasi">
            <Input readOnly value={passport.current_project.division.label}/>
          </Item>
          <Item name="Nama Proyek">
            <Input readOnly value={passport.current_project.project.name}/>
          </Item>
        </>
      )}
    </div>
  );
}

export default PassportDetail;